module.exports = __webpack_public_path__ + "img/刘姗娜.237aa12e.jpg";